import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@cloudscape-design/global-styles/index.css";
import "./index.scss";
import "./i18n";
import ConfigProvider from "./context/config-provider";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router";
import ConnectedProvider from "./core/ConnectedProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  process.env.NODE_ENV === "production" ? (
    <React.StrictMode>
      <Router basename={process.env.PUBLIC_URL}>
        <ConnectedProvider>
          <ConfigProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </ConfigProvider>
        </ConnectedProvider>
      </Router>
    </React.StrictMode>
  ) : (
    <Router basename={process.env.PUBLIC_URL}>
      <ConnectedProvider>
        <ConfigProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </ConfigProvider>
      </ConnectedProvider>
    </Router>
  )
);
